var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('LoadingOverlay'),(_vm.hasCurrentUserData)?_c('Menu'):_vm._e(),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"main-content"})],1),_c('Alert')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }